module.exports = __webpack_public_path__ + "img/4_80.9f28950f.png";